import { useLocation, useNavigate } from "react-router-dom"
import LoadingModal from "../../ui/LoadingModal/LoadingModal"
import { useEffect, useMemo, useState } from "react"
import { confirmAccaunt } from "../../api/user"
import { AUTH_URL } from "../../utils"
import styles from './ConfirmPage.module.scss'


export const ConfirmPage = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const token = useMemo(() => {
    const serchParams = new URLSearchParams(location.search)
    return serchParams.get('token')
  }, [location])

  const [inProgress, setInProgress] = useState(true)
  const [isError, setIsError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    if (!token) { return; }

    (async () => {
      setInProgress(true)
      const {error, message} = await confirmAccaunt(token)
      setInProgress(false)

      setIsError(error)
      setErrorMessage(message || 'Произошла ошибка')

      if (!error) {
        setTimeout(() => {
          navigate(AUTH_URL)
        }, 5e3)
      }
    })()
  }, [token])

  return (
    <div className={styles.root}>
      {inProgress && <LoadingModal title="Подтверждение создания аккаунта..."/>}
      {!inProgress && !isError && <LoadingModal title="Аккаунт создан. Переводим на форму авторизации..."/>}
      {isError && <h2>{errorMessage}</h2>}
    </div>
  )
}